import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import ScheduleList from './ScheduleList.jsx';
import AddCalendar from './AddCalendar.jsx';
import MainLayout from './MainLayout.jsx';
import * as routes from '../constants/routes';
import SessionContext from './SessionContext';
import { withRouter } from 'react-router-dom';
import EditEntryTile from './EditEntryTile.jsx';
import Loading from './Loading';
import MixpanelContext from 'react-mixpanel';

function SchedulesPage({history}) {
  const sessionContext = useContext(SessionContext);
  const mixpanel = useContext(MixpanelContext);

  const [schedules, setSchedules] = useState([])
  const [loading, setLoading] = useState(true)
  const [editingEntry, setEditingEntry] = useState(null)

  const fetchSchedules = async (initialPageLoad = false) => {
    try {
      // TODO: Make these dates real
      const nextEventCutoffAt = moment().add(1, 'd').utc().format();
      const nextAvailableCutoffAt = moment().add(1, 'd').utc().format();

      const client = sessionContext.getGraphqlClient()
      const query = `
        query LoadSchedules {
          getHousehold(householdId: "${sessionContext.household.householdId}") {
            schedules {
              id: scheduleId
              title
              currentEvents {
                eventId
                title
                startAt
                endAt
                creator {
                  profileId
                  given_name
                  family_name
                  picture
                }
              }
              nextEvent(cutoffAt: "${nextEventCutoffAt}") {
                eventId
                title
                startAt
                endAt
                creator {
                  profileId
                  given_name
                  family_name
                  picture
                }
              }
              nextAvailableAt(cutoffAt: "${nextAvailableCutoffAt}", minTimeBlock: 15)
            }
          }
        }
      `

      const request = {
        query,
        variables: null,
        operationName: 'LoadSchedules'
      };

      const resp = await client(request)
      const schedules = resp.data.getHousehold.schedules;

      setSchedules(schedules)
      if(initialPageLoad) {
        mixpanel.track('WFH_Dashboard_Opened', { schedule_count: schedules.length })
      }
    } catch(e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if(!sessionContext.isLoading) {
      if(!sessionContext.isAuthenticated) {
        history.push(routes.LANDING)
      } else if(!sessionContext.household) {
        history.push(routes.ONBOARDING)
      } else {
        fetchSchedules()
      }
    }
  }, [sessionContext.isLoading])

  const addCalendar = async (title) => {
    const client = sessionContext.getGraphqlClient()
    const query = `
      mutation CreateSchedule {
        createSchedule(householdId: "${sessionContext.household.householdId}", title: "${title}") {
          scheduleId
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'CreateSchedule'
    }

    const createResp = await client(request)
    await fetchSchedules();
  }

  const addEntry = (schedule) => {
    setEditingEntry({ schedule: schedule })
    mixpanel.track('WFH_Add_Item_Opened')
  }

  const deleteEntry = async (entry) => {
    const { id, schedule, title } = entry

    const client = sessionContext.getGraphqlClient()
    const query = `
      mutation RemoveEvent {
        removeEvent(householdId: "${sessionContext.household.householdId}", scheduleId: "${schedule.id}", eventId: "${id}") {
          eventId
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'RemoveEvent'
    }

    const createResp = await client(request)

    setEditingEntry(null)
    fetchSchedules()
  }

  const afterNewEntry = async (entry) => {
    const { id, scheduleId, title, notes, startAt, endAt } = entry
    const renderedNotes = notes ? `notes: "${notes}",` : '';
    const event = `{ title: "${title}", ${renderedNotes} startAt: "${startAt}", endAt: "${endAt}"}`
    const client = sessionContext.getGraphqlClient()
    const eventId = id ? `eventId: "${id}",` : '';
    const query = `
      mutation UpdateEvent {
        updateEvent(householdId: "${sessionContext.household.householdId}", scheduleId: "${scheduleId}", ${eventId} event: ${event}) {
          eventId
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'UpdateEvent'
    }

    const createResp = await client(request)
    setEditingEntry(null)
    fetchSchedules()
  }

  return (
    <MainLayout>
      { loading && <Loading fullPage={true} /> }
      { !loading && <>
        { !editingEntry && <>
          <ScheduleList schedules={schedules} onAddEntry={addEntry} onEditEntry={(entry) => setEditingEntry(entry)} />
          <AddCalendar onAddCalendar={addCalendar} hasSchedules={schedules.length > 0}/>
        </>}
        { editingEntry && <EditEntryTile entry={editingEntry} onDelete={deleteEntry} onCancel={() => setEditingEntry(null)} afterSubmit={afterNewEntry} />}
      </>}
    </MainLayout>
  );
}

export default withRouter(SchedulesPage);
